<template>
    <animate-height
        :height="status !== 'not-started' ? 'auto' : 0"
        :duration="200"
        v-on:animation-end="
        obj => {
            const newHeight = obj.newHeight
            if (newHeight == 0) {
                showNotification = false
            }
        }
        "
    >
        <transition
            enter-active-class="vx-transition vx-ease-out vx-duration-200 vx-delay-75 vx-origin-right"
            enter-from-class="vx-opacity-0 -vx-translate-y-10"
            enter-to-class="vx-opacity-100 vx-translate-y-0"
        >
            <progress-notification
                v-if="showNotification"
                :icon="
                status === 'running'
                    ? faCircleInfo
                    : status === 'completed'
                        ? faCheckCircle
                        : faReplyClock
                "
                :blocks="props.blocks"
                :activeBlock="activeBlock"
                class="vx-border vx-border-solid vx-border-sky-200 vx-transition"
                :class="
                    status !== 'not-started'
                        ? ' '
                        : '-vx-translate-y-10 vx-opacity-0'
                "
            >
                <div>
                    {{ title }}
                </div>
                <template v-slot:caption>
                    {{ caption }}
                </template>
            </progress-notification>
        </transition>
    </animate-height>
</template>

<script setup>
import AnimateHeight from 'vue-animate-height'
import {
    faCircleInfo,
    faReplyClock,
    faCheckCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { ref, watch } from 'vue'
import ProgressNotification from './ProgressNotification.vue'
import { computed } from 'vue';

const status = defineModel('status', {
    type: String,
    default: 'not-started', // possibilities: not-started, running, cancelled, completed
});

const props = defineProps({
    activeBlock: {
        type: Number,
        default: 0,
    },
    blocks: {
        type: Number,
        default: 3,
    },
    defaultTitle: {
        type: String,
        default: 'Preparing your long running process…',
    },
    defaultCaption: {
        type: String,
        default: 'Loading',
    },
});

const startTime = ref(0);
const endTime = ref(0);

const title = computed(() => {
    if (status.value === 'completed') {
        return 'Process complete!';
    }
    if (status.value === 'cancelled') {
        return 'This is taking longer than expected';
    }

    return props.defaultTitle;
});

const caption = computed(() => {
    if (status.value === 'completed') {
        return `Finished in ${Math.floor((endTime.value - startTime.value) / 1000)} seconds.`;
    }
    if (status.value === 'cancelled') {
        return 'Please check back in 10 min.';
    }

    return `${props.defaultCaption}, next update in a few seconds.`;
});

const showNotification = ref(false)

let completedTimeout;
watch(() => status.value, async (currentStatus) => {
    clearTimeout(completedTimeout);
    if (currentStatus === 'not-started') {
        startTime.value = 0;
        endTime.value = 0;
    } else if (currentStatus === 'running') {
        showNotification.value = true;
        startTime.value = Date.now();
    } else if (currentStatus === 'completed') {
        endTime.value = Date.now();

        // restarts after 5 seconds
        completedTimeout = setTimeout(() => {
            status.value = 'not-started';
        }, 5000);
    }
}, {
    immediate: true,
})


</script>
